// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ObjectDetailHeaderWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  position: relative;
  border-bottom: 1px solid var(--mb-color-border);
`;

export const ObjectIdLabel = styled.span`
  color: var(--mb-color-text-secondary);
  margin-left: 0.5rem;
`;

export const CloseButton = styled.div`
  display: flex;
  margin-left: 1rem;
  padding-left: 1rem;
  border-left: 1px solid var(--mb-color-border);
`;
